import {Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {SelectElementModelFE} from "../../api/types/generic";
import {FormAutocomplete} from "../form-fields";
import {RentalPeriodEntityResponse} from "../../api/types/rentalPeriods";
import {MatrixInitializationValues as rateMatrixInitializationValues} from "../../api/types/rateDetail";
import {MatrixInitializationValues as ancillaryMatrixInitializationValues} from "../../api/types/ancillaryDetail";
import {useFormContext} from "react-hook-form";

const CarGroupsAndRentalPeriods = ({
                                       carGroups,
                                       rentalPeriods,
                                       handleChangeCarGroups,
                                       handleChangeRentalPeriods,
                                       rentalPeriodsAbsolute,
                                       absolute
                                   }: {
    carGroups: string[],
    rentalPeriods: RentalPeriodEntityResponse[],
    handleChangeCarGroups?: Function
    handleChangeRentalPeriods?: Function,
    rentalPeriodsAbsolute?: RentalPeriodEntityResponse[],
    absolute?: boolean
}) => {
    // Use Form Context
    const {
        watch,
        setValue,
        register
    } = useFormContext<rateMatrixInitializationValues | ancillaryMatrixInitializationValues>();
    const watchAllForm = watch();

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use State
    const [rentalPeriodOptions, setRentalPeriodOptions] = useState<SelectElementModelFE[]>([]);
    const [carGroupsOptions, setCarGroupsOptions] = useState<string[]>([]);
    const [rentalPeriodAbsoluteOptions, setRentalPeriodAbsoluteOptions] = useState<SelectElementModelFE[]>([]);


    useEffect(() => {
        if (rentalPeriods?.length > 0) setRentalPeriodOptions(
            [{code: 0, label: t("pricing:actions.selectAll")},
                ...rentalPeriods.map((rp: RentalPeriodEntityResponse) => ({code: Number(rp.id), label: rp.name}))]
        );

        // eslint-disable-next-line
    }, [rentalPeriods]);

    useEffect(() => {
        if ((rentalPeriodsAbsolute as RentalPeriodEntityResponse[])?.length > 0) setRentalPeriodAbsoluteOptions(
            [{code: 0, label: t("pricing:actions.selectAll")},
                ...(rentalPeriodsAbsolute as RentalPeriodEntityResponse[])?.map((rp: RentalPeriodEntityResponse) => ({
                    code: Number(rp.id),
                    label: rp.name
                }))]
        );
        // eslint-disable-next-line
    }, [rentalPeriodsAbsolute]);

    useEffect(() => {
        if (carGroups?.length > 0) setCarGroupsOptions(
            [t("pricing:actions.selectAll"), ...carGroups]
        );
        // eslint-disable-next-line
    }, [carGroups]);

    const onChangeRentalPeriods = (input: SelectElementModelFE[]) => {
        const value: SelectElementModelFE[] =
            // è stato cliccato "selectAll"
            input.find((el: SelectElementModelFE) => el.code === 0)
            &&
            // tra i vecchi valori non c'è "selectAll
            !watchAllForm.rentalPeriods?.find((el: SelectElementModelFE) => el.code === 0)
                ?
                // applica il "selectAll
                rentalPeriodOptions.filter((el: SelectElementModelFE) => el.code !== 0)
                :
                // setta solo i rental period selezionati
                input.filter(el => el.code !== 0);
        if (handleChangeRentalPeriods) {
            handleChangeRentalPeriods(value);
        }
        // @ts-ignore
        setValue("rentalPeriods", value);
    };

    const onChangeRentalPeriodsAbsolute = (input: SelectElementModelFE[]) => {
        const value: SelectElementModelFE[] =
            // è stato cliccato "selectAll"
            input.find((el: SelectElementModelFE) => el.code === 0)
            &&
            // tra i vecchi valori non c'è "selectAll
            !watchAllForm.rentalPeriods?.find((el: SelectElementModelFE) => el.code === 0)
                ?
                // applica il "selectAll
                rentalPeriodAbsoluteOptions.filter((el: SelectElementModelFE) => el.code !== 0)
                :
                // setta solo i rental period selezionati
                input.filter(el => el.code !== 0);
        if (handleChangeRentalPeriods) {
            handleChangeRentalPeriods(value);
        }
        setValue("rentalPeriods", value);
    };

    const onChangeCarGroups = (input: string[]) => {
        const value: string[] =
            // è stato cliccato "selectAll
            input.find((el: string) => el === t("pricing:actions.selectAll"))
            &&
            // tra i vecchi valori non c'è "selectAll
            !watchAllForm.carGroups?.find((el: string) => el === t("pricing:actions.selectAll"))
                ?
                // applica il "selectAll
                carGroupsOptions.filter((el: string) => el !== t("pricing:actions.selectAll"))
                :
                // setta solo i car group selezionati
                input.filter(el => el !== t("pricing:actions.selectAll"));
        // const value: string[] = input.find((el: string) => el === t("pricing:actions.selectAll")) ? carGroupsOptions : input;
        if (handleChangeCarGroups) {
            handleChangeCarGroups(value);
        }
        setValue("carGroups", value);
    };

    return (
        <>
            <Grid item xs={12} md={3}>
                <FormAutocomplete {...register("carGroups")}
                                  label={`${t("pricing:ancillaryMatrixInsert.form.labels.carGroups")}*`}
                                  options={carGroupsOptions}
                                  multiple={true}
                                  handleChange={onChangeCarGroups}
                                  isOptionEqualToValue={(option, value) => option === value}
                />
            </Grid>
            {!absolute ?
                <Grid item xs={12} md={3}>
                    <FormAutocomplete {...register("rentalPeriods")}
                                      label={`${t("pricing:ancillaryMatrixInsert.form.labels.rentalPeriods")}*`}
                                      options={rentalPeriodOptions}
                                      multiple={true}
                                      handleChange={onChangeRentalPeriods}
                                      isOptionEqualToValue={(option, value) => option.code === value.code}
                    />
                </Grid> :
                <Grid item xs={12} md={3}>
                    <FormAutocomplete {...register("rentalPeriods")}
                                      label={`${t("pricing:ancillaryMatrixInsert.form.labels.rentalPeriods")}*`}
                                      options={rentalPeriodAbsoluteOptions}
                                      multiple={true}
                                      handleChange={onChangeRentalPeriodsAbsolute}
                                      isOptionEqualToValue={(option, value) => option.code === value.code}
                    />
                </Grid>}
        </>
    );
};

export default CarGroupsAndRentalPeriods;